export default "__VITE_ASSET__DZP9O4D6__"